import { CpsSearchQueryRequest, CpsSearchQueryResult, CpsSearchExportRequest } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class SearchService {
  public async getSearchResults(querySearchRequest: CpsSearchQueryRequest): Promise<CpsSearchQueryResult> {
    return ExecuteEndpoint(`search`, 'POST', { json: querySearchRequest });
  }

  public async triggerExportToCsv(querySearchExportRequest: CpsSearchExportRequest): Promise<void> {
    return ExecuteEndpoint(`search/export`, 'POST', { json: querySearchExportRequest });
  }
}
